import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportExport, ReportExportKind, ReportExportsState, ReportExportsStore } from '../../services/report-exports.store';

// the Raporty tab the file is of, beside its range (0118)
const KIND_LABELS: Record<ReportExportKind, string> = {
  progress: 'Raporty',
  materials: 'Zapotrzebowanie'
};

/**
 * The small window in the bottom-right corner of the shell where the Excel exports of Raporty
 * run and wait (0107): one card per export — Przygotowuję plik… while the API builds it, Plik
 * gotowy with Pobierz when it has arrived, Nie udało się przygotować pliku with Spróbuj ponownie
 * when it has not. A card does not close when its file lands — the user may be on another page —
 * only a few seconds after Pobierz, fading out, or when its × is clicked. Rendered once in the
 * shell, hidden when empty.
 */
@Component({
  selector: 'export-tray',
  templateUrl: './export-tray.component.html',
  styleUrl: './export-tray.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe]
})
export class ExportTrayComponent {
  readonly state$: Observable<ReportExportsState>;

  constructor(private store: ReportExportsStore) {
    this.state$ = this.store.state$;
  }

  // "Zapotrzebowanie · 2026-10-01 – 2026-10-23": which report, and the days as its tab showed them
  rangeLabel(entry: ReportExport): string {
    return `${KIND_LABELS[entry.kind]} · ${entry.from} – ${entry.to}`;
  }

  download(entry: ReportExport): void {
    this.store.download(entry.id);
  }

  retry(entry: ReportExport): void {
    this.store.retry(entry.id);
  }

  dismiss(entry: ReportExport): void {
    this.store.dismiss(entry.id);
  }
}
